module.exports = __webpack_public_path__ + "static/img/icon-link.419ab97f.svg";